var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isTemplate)?_c('div',{staticClass:"template-name"},[_c('string',{attrs:{"placeholder":"Template Name","label":"Template Name","value":_vm.value,"rules":[{ Type: 'required' }]},on:{"setConfigValue":_vm.setConfigValue}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }